import { createAsyncThunk } from "@reduxjs/toolkit";
import fsrHttpInstance, { fsrHttpConfiguration } from "../serviceFsrClients";
import { normalizeEntity } from "../entities/paymentEntity";
import { setFlashError } from "../slices/commons/flashSliceCommon";

export const fetchPayments = createAsyncThunk(
	"datasources/payments/fetchPayments",
	async (request, thunkAPI) => {
		try {
			const params = request ? { params: request.query } : {};
			const response = await fsrHttpInstance.then(fsrService => fsrService.get("vendor/payments/index", {...params, ...fsrHttpConfiguration()}));
			const normalized = normalizeEntity(response.data.payments);
			
			return { 
				...normalized, 
				pagination: response.data.pagination || {} 
			};
		} catch (exception) {
			thunkAPI.dispatch(setFlashError("The payment could not be loaded. Please, try again."));
			return thunkAPI.rejectWithValue(exception.response.data);
		}
	}
);